export const environment = {
  production: true,
  apiUrl: 'https://api.rwayz.net/user'
};
